export class Pagination {
    pageIndex = 0;
    pageSize = 10;
    pageSizeOptions: Array<number> = [10, 25, 50, 100];
    totalItems = 0;
    totalPages = 0;
    currentItems = 0;
    currentPage = 0;
    disablePagination = false;
}